import React from 'react';
import styles from './CredentialsPageContainer.module.scss';
import { Icon, Text } from 'components';

type Props = {
  formTitle: string;
  formSubtitle: string;
  children: React.ReactNode;
};

export const CredentialsPageContainer = ({ formTitle, formSubtitle, children }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.leftContainer}>
        <Icon name="CircleLogo" className={styles.logo} />
        <Text type="h2" className={styles.title}>
          Urban Smile communication and diagnosis app
        </Text>
      </div>
      <div className={styles.mobileHeader}>
        <Icon name="Logo" className={styles.mobileLogo} />
        <Text type="h3" className={styles.mobileFormTitle}>
          {formTitle}
        </Text>
      </div>
      <div className={styles.rightContainer}>
        <div className={styles.content}>
          <Text type="h4" className={styles.formTitle}>
            {formTitle}
          </Text>
          <Text className={styles.formSubtitle} type="h5">
            {formSubtitle}
          </Text>
          {children}
        </div>
      </div>
    </div>
  );
};
